import React, { Fragment } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle, Button } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import queryString from 'query-string';
import { DropDownStyle, DropDownFixed } from './style';
import { TrackGoogleAnalyticsEvent } from '../utils/googleAnalytics';
import { ClickMenu, ClickMenuAction } from '../utils/googleAnalytics/events/EventMenu';

class DropdownControlledDrawer extends React.Component {
  state = {
    isOpen: false,
    isHovering: false
  };

  // FIXME: Corrigir isso para um módulo configuravel via admin por exemplo.
  // Estou fazendo isso para não ter que reconfigurar diversos menus
  // Não vai funcionar em dev...
  goToExternalLink = (link) => {
    const parser = document.createElement('a');
    parser.href = link;

    if (parser.hostname.includes('exams')) {
      const pathName = `/external-application-middleware?${queryString.stringify(
        { applicationName: 'exams', path: parser.pathname, forceLogout: false }
      )}`;
      window.open(pathName, '_self');
    } else {
      window.open(link, '_self');
    }
  };
  toggle = (url) => {
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });

    const {
      location: { pathname }
    } = this.props;
    if (pathname === url) {
      window.location.reload();
    }

  };

  handleMouseBillboardEnter = () => {
    this.setState({ isHovering: true });
  };

  handleMouseBillboardLeave = () => {
    this.setState({ isHovering: false });
  };

  handleMouseLeaveMenu = () => {
    this.setState({ isOpen: false });
  }

  handleMouseEnter = () => {
    this.setState({ isHovering: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovering: false });
  };

  componentDidMount() {
    const { leave } = this.props;
    if (!leave) {
      this.setState({ isOpen: false });
    }
  }

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickMenu + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickMenuAction,
      label,
    );
  };

  mapOption = (option) => {
    const { menu, history } = this.props;
    const isExternalLink = get(menu, 'is_external_link');

    if (!option.enabled) {
      return (
        <button
          key={option.id}
          className="dropdown-item children-menu disabled"
          onClick={() => this.analytcsClick(option.name, "Sub_Iten")}
        >
          {option.name}
        </button>
      );
    }
    return (
      <Link
        key={option.id}
        className="dropdown-item children-menu"
        style={{ color: '#fff', wordWrap: 'break-word', maxWidth: '100px' }}
        onClick={() => {
          isExternalLink ? (
            this.goToExternalLink(option.url)
          ) : (
            this.toggle(option.url)
          );
          this.analytcsClick(option.name, "Sub_Iten");
        }}
        to={isExternalLink || option.url || '/'}
      >
        {option.name}
      </Link>
    );
  };

  mapSection = (section) => {
    const options = get(section, 'options') || [];

    return (
      <Fragment key={section.id}>
        {section.name && (
          <span
            className="dropdown-item divider-menu"
            style={{ color: '#fff', textTransform: 'capitalize', padding: "0", marginLeft: "25px" }}
          >
            {section.name}
          </span>
        )}
        {map(options, this.mapOption)}
      </Fragment>
    );
  };

  render() {
    const { isOpen, isHovering } = this.state;
    const { menu, drawer, leave, history } = this.props;
    const name = get(menu, 'name');
    const iconName = get(menu, 'icon_name');
    const sections = get(menu, 'sections') || [];
    const isExternalLink = get(menu, 'is_external_link');

    return (
      <>
        {sections.length === 0 ? (
          <Dropdown
            className="nav"
            isOpen={isOpen}
            toggle={this.toggle}
            style={{ width: '100%', margin: '0' }}
            onMouseLeave={this.handleMouseLeaveMenu}
          >
            <DropDownStyle>
              <Button
                className="dropdown-toggle-container  active-menu-drawer"
                style={{
                  textAlign: 'left',
                  width: '100%',
                  borderRadius: '8px',
                  justifyContent: 'flex-start',
                }}
                onMouseOver={this.handleMouseBillboardEnter}
                onMouseLeave={this.handleMouseBillboardLeave}
              >
                <Link
                  style={{
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => {
                    isExternalLink ? (
                      this.goToExternalLink(menu.url)
                    ) : (
                      this.toggle(menu.url)
                    );
                    this.analytcsClick(name, "Iten");
                  }}
                  to={isExternalLink || menu.url || '/'}
                >
                  <span
                    className={`icon-${iconName}`}
                    style={{
                      color: '#fff',
                      fontSize: '24px',
                      marginLeft: '0.1rem',
                    }}
                  />
                  <span
                    style={{
                      opacity: drawer ? '0' : '1',
                      marginLeft: drawer ? '3.5rem' : '0.9rem',
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    {name}
                  </span>
                </Link>
              </Button>
            </DropDownStyle>
          </Dropdown>
        ) : (
          leave ? (
            <Dropdown
              className="nav"
              isOpen={isOpen}
              toggle={this.toggle}
              style={{ width: '100%', margin: '0' }}
            >
              <DropDownStyle>
                <DropdownToggle
                  className={`dropdown-toggle-container active-menu-drawer`}
                  key={name}
                  style={{
                    textAlign: 'left',
                    width: '100%',
                    borderRadius: isOpen ? '5px 5px 0px 0px' : '',
                    color: '#fff',
                    padding: '1rem',
                  }}
                  onMouseOver={this.handleMouseEnter}
                  onMouseLeave={this.handleMouseLeave}
                  onClick={() => (this.analytcsClick(name, "Iten"))}
                  caret
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <span
                      className={`icon-${iconName}`}
                      style={{
                        color: '#fff',
                        fontSize: '24px',
                        marginLeft: '-0.3rem',
                      }}
                    />
                    <span
                      style={{
                        fontFamily: 'Public Sans',
                        opacity: drawer ? '0' : '1',
                        marginLeft: '0.9rem',
                        color: '#fff',
                        fontSize: '14px',
                        fontWeight: 'bold'
                      }}
                    >
                      {name}
                    </span>
                  </div>
                </DropdownToggle>
              </DropDownStyle>
              <DropdownMenu
                className="dropdown-menu-drawer"
                style={{
                  transition: 'all 0.1s',
                  width: '100%',
                  marginLeft: drawer ? '10px' : '0',
                  th: '100%',
                  display: drawer ? 'none' : isOpen ? 'contents' : '',
                }}
              >
                <DropDownFixed>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      paddingBottom: '8px',
                      borderRadius: '0 0 5px 5px',
                    }}
                  >
                    {map(sections, this.mapSection)}
                  </div>
                </DropDownFixed>
              </DropdownMenu>
            </Dropdown>
          ) : (
            <Dropdown
              className="nav"
              isOpen={isOpen}
              toggle={this.toggle}
              style={{ width: '100%', margin: '0' }}
            >
              <DropDownStyle>
                <div
                  className={`dropdown-toggle-container active-menu-drawer`}
                  key={name}
                  style={{
                    textAlign: 'left',
                    width: '100%',
                    borderRadius: isOpen ? '5px 5px 0px 0px' : '',
                    color: '#fff',
                    padding: '1rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <span
                      className={`icon-${iconName}`}
                      style={{
                        color: '#fff',
                        fontSize: '24px',
                        marginLeft: '-0.3rem',
                      }}
                    />
                  </div>
                </div>
              </DropDownStyle>
            </Dropdown>
          )
        )}
      </>
    );
  }
}

DropdownControlledDrawer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  menu: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired
          }).isRequired
        ).isRequired
      }).isRequired
    ).isRequired
  }).isRequired
};

export default withRouter(DropdownControlledDrawer);
